import { ThemeConfigContext } from 'components/common/ThemeConfigProvider/ThemeConfigProvider';
import { useContext } from 'react';

const useThemeConfig = () => {
    return useContext(ThemeConfigContext);
};

export default useThemeConfig;
